import { useCallback, useMemo } from 'react';
import { TableFetchParams, tableQueryMaker, TableState } from '@core/table';
import { useService } from '@core/inversify-react';

import { GetDeclarationsPostRepoType, IGetDeclarationsPostRepo } from '../../repos';

export const usePostDeclarationTableContext = () => {
  const getPostDeclarationsRepo = useService<IGetDeclarationsPostRepo>(GetDeclarationsPostRepoType);

  const handleFetch = useCallback(
    async (params: TableFetchParams) => {
      const result = await getPostDeclarationsRepo.execute(tableQueryMaker(params));

      if (result.status === 200) {
        return {
          data: result.response.data,
          total: result.response.total,
        };
      } else {
        throw new Error(result.response);
      }
    },
    [getPostDeclarationsRepo],
  );

  const defaultState = useMemo<Partial<TableState>>(
    () => ({
      filters: [],
    }),
    [],
  );

  return { handleFetch, defaultState };
};
